module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-1-8b5a47c60f98adf456093cd8f764e697.jpg";